import { ChangeDetectorRef, Component, inject, OnInit, ChangeDetectionStrategy, DOCUMENT } from '@angular/core';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { LocalizationService } from '../../../Services/localization-service';
import { SeoService } from '../../../Services/SeoService';
interface TermModelItem {
  title: string;
  content: string;
  order: number;
}
interface TermModel {
  items: TermModelItem[];
}
@Component({
  selector: 'app-terms-component',
  imports: [TranslatePipe],
  templateUrl: './terms-component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './terms-component.scss'
})
export class TermsComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly document = inject(DOCUMENT);
  private readonly localizationService = inject(LocalizationService);
  private readonly seoService = inject(SeoService);

  ngOnInit(): void {
    this.localizationService.getLanguage().subscribe(lang => {
      if (lang != '') {
        const canonicalUrl = `${this.document.location.origin}/${lang}/terms`;
        this.seoService.updateCanonicalUrl(canonicalUrl);
        this.cdr.detectChanges();
      }
    });
  }


  termModel: TermModel = {
    items: [
      { title: this.translate.instant('TERM_TITLE1'), content: this.translate.instant('TERM_CONTENT1'), order: 1 },
      { title: this.translate.instant('TERM_TITLE2'), content: this.translate.instant('TERM_CONTENT2'), order: 2 },
      { title: this.translate.instant('TERM_TITLE3'), content: this.translate.instant('TERM_CONTENT3'), order: 3 },
      { title: this.translate.instant('TERM_TITLE4'), content: this.translate.instant('TERM_CONTENT4'), order: 4 },
      { title: this.translate.instant('TERM_TITLE5'), content: this.translate.instant('TERM_CONTENT5'), order: 5 },
      { title: this.translate.instant('TERM_TITLE6'), content: this.translate.instant('TERM_CONTENT6'), order: 6 },
      { title: this.translate.instant('TERM_TITLE7'), content: this.translate.instant('TERM_CONTENT7'), order: 7 },
      { title: this.translate.instant('TERM_TITLE8'), content: this.translate.instant('TERM_CONTENT8'), order: 8 },
      { title: this.translate.instant('TERM_TITLE9'), content: this.translate.instant('TERM_CONTENT9'), order: 9 },
      { title: this.translate.instant('TERM_TITLE10'), content: this.translate.instant('TERM_CONTENT10'), order: 10 },
      { title: this.translate.instant('TERM_TITLE11'), content: this.translate.instant('TERM_CONTENT11'), order: 11 },
    ]
  }




}